import { render, staticRenderFns } from "./PlgSupportPointsStatements.vue?vue&type=template&id=d555de24&scoped=true&"
import script from "./PlgSupportPointsStatements.vue?vue&type=script&lang=js&"
export * from "./PlgSupportPointsStatements.vue?vue&type=script&lang=js&"
import style0 from "./PlgSupportPointsStatements.vue?vue&type=style&index=0&id=d555de24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d555de24",
  null
  
)

export default component.exports